(() => {
  const start = () => {
    document.querySelectorAll('.product__info-container:has(.txn-selected-purpose)').forEach(root => {
      if (root.dataset.txnPurchaseReady) return;
      root.dataset.txnPurchaseReady = 'true';
      let desiredPlan = new URL(location.href).searchParams.get('selling_plan') || '';
      let lastVariant = '';
      let updating = false;
      const reconcile = () => {
        if (updating) return;
        const input = root.querySelector('product-form form input[name="id"]');
        if (!input) return;
        root.querySelectorAll('[data-txn-purpose-variant]').forEach(el => {el.hidden = el.dataset.txnPurposeVariant !== input.value;});
        const section = root.querySelector('.shopify_subscriptions_app_block[data-variant-id="' + input.value + '"]');
        if (!section) return;
        updating = true;
        if (lastVariant !== input.value) {
          const options = [...section.querySelectorAll('input[data-radio-type]')];
          const option = options.find(el => desiredPlan && el.dataset.sellingPlanId === desiredPlan) || options.find(el => el.dataset.radioType === 'one_time_purchase');
          if (option) {
            option.checked = true;
            option.dispatchEvent(new Event('change', {bubbles:true}));
            desiredPlan = option.dataset.sellingPlanId || '';
          }
          lastVariant = input.value;
        }
        root.querySelectorAll('[data-txn-sub-note]').forEach(el => {el.hidden = !desiredPlan;});
        root.querySelectorAll('.shopify_subscriptions_app_policy').forEach(el => {el.hidden = !desiredPlan;});
        root.querySelectorAll('[data-txn-once-note]').forEach(el => {el.hidden = !!desiredPlan;});
        root.querySelectorAll('[data-txn-unit]').forEach(el => {
          const copy = desiredPlan ? el.dataset.sub : el.dataset.once;
          if (el.textContent !== copy) el.textContent = copy;
        });
        root.querySelectorAll('.in_widget_price').forEach(el => el.removeAttribute('aria-hidden'));
        root.querySelectorAll('[data-txn-pack-link]').forEach(link => {
          const variants = JSON.parse(link.dataset.variants);
          const current = root.querySelector('variant-selects [data-selected-variant]');
          const selected = current ? JSON.parse(current.textContent) : null;
          const target = variants.find(v => selected && (v.option1 === selected.option1 || (v.option1.includes('MIX') && selected.option1.includes('MIX'))));
          const url = new URL(link.href);
          if (target) url.searchParams.set('variant', target.id);
          if (desiredPlan && link.dataset.plan) url.searchParams.set('selling_plan', link.dataset.plan);
          else url.searchParams.delete('selling_plan');
          const preview = new URL(location.href).searchParams.get('preview_theme_id');
          if (preview) url.searchParams.set('preview_theme_id', preview);
          if (link.href !== url.href) link.href = url.href;
        });
        updating = false;
      };
      root.addEventListener('change', e => {
        if (e.target.matches('input[data-radio-type]')) {
          desiredPlan = e.target.dataset.sellingPlanId || '';
          const url = new URL(location.href);
          if (desiredPlan) url.searchParams.set('selling_plan', desiredPlan);
          else url.searchParams.delete('selling_plan');
          history.replaceState(history.state, '', url);
        }
        queueMicrotask(reconcile);
      });
      const observer = new MutationObserver(records => {
        if (records.some(r => r.type === 'childList' || (r.target.matches?.('input[name="id"]') && r.attributeName === 'value'))) queueMicrotask(reconcile);
      });
      observer.observe(root, {childList:true, subtree:true, attributes:true, attributeFilter:['value']});
      reconcile();
      window.addEventListener('pageshow', reconcile);
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once:true});
  else start();
})();


